
(function () {
  if (window.__camotecAtcInit) return;
  window.__camotecAtcInit = true;

  if (!window.__notifyDrawerInit) {
    window.__notifyDrawerInit = true;
    window.openNotifyDrawer = function(title, price) {
      const drawer  = document.getElementById('NotifyDrawer');
      const overlay = document.getElementById('NotifyOverlay');
      if (!drawer) return;
      const elTitle = document.getElementById('NotifyProductTitle');
      const elPrice = document.getElementById('NotifyProductPrice');
      const elInput = document.getElementById('NotifyProductInput');
      if (elTitle) elTitle.textContent = title || '';
      if (elPrice) elPrice.textContent = price || '';
      if (elInput) elInput.value = title || '';
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };

    window.closeNotifyDrawer = function() {
      const drawer  = document.getElementById('NotifyDrawer');
      const overlay = document.getElementById('NotifyOverlay');
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'true');
        drawer.classList.remove('is-open');
      }
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    document.addEventListener('click', function(e) {
      if (e.target.closest('.js-notify-close')) window.closeNotifyDrawer();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') window.closeNotifyDrawer();
    });
  }

  if (!window.__sizeDrawerInit) {
    window.__sizeDrawerInit = true;

    function sd_waitFor(cond, timeout) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
        (function check() {
          if (cond()) return resolve(true);
          if (Date.now() - start > timeout) return reject();
          requestAnimationFrame(check);
        })();
      });
    }

    function sd_findPicker(btn) {
      let scope = btn ? btn.closest('[id^="shopify-section-"]') : null;
      let picker = scope ? scope.querySelector('variant-picker') : null;
      return picker || document.querySelector('variant-picker');
    }

    function sd_getMainAddButton(picker) {
      let scope = picker ? picker.closest('[id^="shopify-section-"]') : null;
      scope = scope || document;
      return scope.querySelector('form[action*="/cart/add"] add-to-cart-component .add-to-cart-button')
          || scope.querySelector('add-to-cart-component .add-to-cart-button')
          || document.querySelector('add-to-cart-component .add-to-cart-button');
    }

    function sd_optionLabel(fs) {
      const legend = fs.querySelector('legend');
      if (!legend) return '';
      const clone = legend.cloneNode(true);
      clone.querySelectorAll('span').forEach(s => s.remove());
      return clone.textContent.trim();
    }

    function sd_refreshAddState() {
      const picker = window.__sizeDrawerPicker;
      const addBtn = document.getElementById('SizeDrawerAdd');
      if (!picker || !addBtn) return;
      let ok = false;
      const fieldsets = picker.querySelectorAll('fieldset');
      if (fieldsets.length) {
        ok = Array.from(fieldsets).every(fs => fs.querySelector('input[type="radio"]:checked'));
      } else {
        const selects = picker.querySelectorAll('select');
        ok = selects.length > 0 && Array.from(selects).every(s => s.value);
      }
      addBtn.disabled = !ok;
    }

    function sd_renderOptions(picker) {
      const wrap = document.getElementById('SizeDrawerOptions');
      wrap.innerHTML = '';

      const fieldsets = picker.querySelectorAll('fieldset');
      if (fieldsets.length) {
        fieldsets.forEach(fs => {
          const group = document.createElement('div');
          group.className = 'size-drawer__group';

          const name = document.createElement('div');
          name.className = 'size-drawer__group-name';
          name.textContent = sd_optionLabel(fs);
          group.appendChild(name);

          const grid = document.createElement('div');
          grid.className = 'size-drawer__grid';

          fs.querySelectorAll('input[type="radio"]').forEach(radio => {
            const labelEl = radio.closest('label');
            const textEl = labelEl ? labelEl.querySelector('.variant-option__button-label__text') : null;
            const txt = textEl ? textEl.textContent.trim() : radio.value;
            const available = radio.dataset.optionAvailable === 'true';

            const pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'size-pill' + (available ? '' : ' is-soldout') + (radio.checked ? ' is-active' : '');
            pill.textContent = txt;

            if (available) {
              pill.addEventListener('click', () => {
                radio.click(); 
                grid.querySelectorAll('.size-pill').forEach(b => b.classList.remove('is-active'));
                pill.classList.add('is-active');
                setTimeout(sd_refreshAddState, 60);
              });
            } else {
              pill.disabled = true;
            }
            grid.appendChild(pill);
          });

          group.appendChild(grid);
          wrap.appendChild(group);
        });
        return;
      }

      picker.querySelectorAll('select').forEach(sel => {
        const group = document.createElement('div');
        group.className = 'size-drawer__group';

        const name = document.createElement('div');
        name.className = 'size-drawer__group-name';
        const lbl = picker.querySelector('label[for="' + sel.id + '"]');
        name.textContent = lbl ? lbl.textContent.trim() : '';
        group.appendChild(name);

        const grid = document.createElement('div');
        grid.className = 'size-drawer__grid';

        Array.from(sel.options).forEach(opt => {
          if (!opt.value) return;
          const soldout = /(недоступ|unavail|відсут|sold)/i.test(opt.textContent);
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'size-pill' + (soldout ? ' is-soldout' : '') + (sel.value === opt.value ? ' is-active' : '');
          pill.textContent = (opt.textContent.replace(/\s*[\u2013\-].*$/, '').trim()) || opt.value;

          if (!soldout) {
            pill.addEventListener('click', () => {
              sel.value = opt.value;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              grid.querySelectorAll('.size-pill').forEach(b => b.classList.remove('is-active'));
              pill.classList.add('is-active');
              setTimeout(sd_refreshAddState, 60);
            });
          } else {
            pill.disabled = true;
          }
          grid.appendChild(pill);
        });

        group.appendChild(grid);
        wrap.appendChild(group);
      });
    }

    async function sd_addFromDrawer() {
      const picker = window.__sizeDrawerPicker;
      if (!picker) return;
      const addBtn = document.getElementById('SizeDrawerAdd');
      if (!addBtn || addBtn.disabled) return;

      try {
        await sd_waitFor(() => {
          const b = sd_getMainAddButton(picker);
          return b
            && b.getAttribute('name') === 'add'
            && !b.classList.contains('is-unselected-state')
            && !b.disabled;
        }, 1800);
      } catch (e) {}

      window.closeSizeDrawer();
      setTimeout(() => {
        const b = sd_getMainAddButton(picker);
        if (b) b.click(); 
      }, 120);
    }

    function sd_build() {
      if (document.getElementById('SizeDrawer')) return;

      const style = document.createElement('style');
      style.id = 'SizeDrawerStyles';
      style.textContent = `
        .size-drawer{position:fixed;inset:0;z-index:1000000;visibility:hidden;pointer-events:none;}
        .size-drawer.is-open{visibility:visible;pointer-events:auto;}
        .size-drawer__overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);opacity:0;transition:opacity .35s ease;}
        .size-drawer.is-open .size-drawer__overlay{opacity:1;}
        .size-drawer__panel{position:fixed;top:0;right:0;height:100vh;width:450px;max-width:100%;background:#fff;display:flex;flex-direction:column;box-shadow:-4px 0 20px rgba(0,0,0,.1);transform:translate3d(100%,0,0);transition:transform .4s cubic-bezier(.25,.46,.45,.94);}
        .size-drawer.is-open .size-drawer__panel{transform:translate3d(0,0,0);}
        .size-drawer__head{display:flex;justify-content:space-between;align-items:center;padding:20px 16px;border-bottom:1px solid #f0f0f0;}
        .size-drawer__title{margin:0;font-family:'Roboto Condensed',sans-serif;font-weight:700;font-size:14px;line-height:100%;letter-spacing:0;text-transform:uppercase;}
        .size-drawer__close{background:none;border:0;font-size:32px;line-height:0;cursor:pointer;padding:0;color:#000;}
        .size-drawer__body{flex:1;overflow-y:auto;padding:16px;}
        .size-drawer__product{margin-bottom:16px;}
        .size-drawer__product-title{font-family:'Roboto Condensed',sans-serif;font-size:16px;font-weight:700;text-transform:uppercase;margin:0 0 4px;}
        .size-drawer__product-price{font-family:Arial,sans-serif;font-size:14px;color:rgba(16,24,33,1); font-weight: 700;}
        .size-drawer__group{margin-bottom:20px;}
        .size-drawer__group-name{font-family:Arial,sans-serif;font-size:12px;color:#888;text-transform:uppercase;margin-bottom:8px;}
        .size-drawer__grid{display:flex;flex-wrap:wrap;gap:8px;}
        .size-pill{min-width:48px;padding:12px 14px;border:1px solid #d6d6d6;background:#fff;cursor:pointer;font-family:'Roboto Condensed',sans-serif;font-weight:700;font-size:16px;line-height:100%;letter-spacing:0;color:rgba(16,24,33,1);text-transform:uppercase;border-radius:0;transition:all .2s ease;}
        .size-pill:hover{border-color:rgba(255,77,28,1);}
        .size-pill.is-active{border-color:rgba(255,77,28,1);background:#fff;color:rgba(16,24,33,1);}
        .size-pill.is-soldout{color:#bbb;border-color:#eee;cursor:not-allowed;text-decoration:line-through;}
        .size-drawer__footer{padding:16px;border-top:1px solid #f0f0f0;}
        .size-drawer__add{width:100%;padding:16px;border:0;background:#000;color:#fff;font-family:Arial,sans-serif;font-weight:400;font-size:14px;line-height:100%;letter-spacing:0;cursor:pointer;}
        .size-drawer__add:disabled{opacity:.4;cursor:not-allowed;}
        @media (max-width:749px){.size-drawer__panel{top:auto;bottom:0;right:0;left:0;width:100%;height:auto;max-height:85vh;transform:translate3d(0,100%,0);}}
      `;
      document.head.appendChild(style);

      const wrap = document.createElement('div');
      wrap.innerHTML = `
        <div id="SizeDrawer" class="size-drawer" aria-hidden="true">
          <div class="size-drawer__overlay" data-size-close></div>
          <div class="size-drawer__panel" role="dialog" aria-modal="true">
            <div class="size-drawer__head">
              <h2 class="size-drawer__title">Оберіть розмір</h2>
              <button class="size-drawer__close" type="button" data-size-close>&times;</button>
            </div>
            <div class="size-drawer__body">
              <div class="size-drawer__product">
                <div class="size-drawer__product-title" id="SizeDrawerTitle"></div>
                <div class="size-drawer__product-price" id="SizeDrawerPrice"></div>
              </div>
              <div class="size-drawer__options" id="SizeDrawerOptions"></div>
            </div>
            <div class="size-drawer__footer">
              <button type="button" class="size-drawer__add" id="SizeDrawerAdd" disabled>Додати в кошик</button>
            </div>
          </div>
        </div>
      `;
      document.body.appendChild(wrap.firstElementChild);

      document.getElementById('SizeDrawerAdd').addEventListener('click', sd_addFromDrawer);
      document.querySelectorAll('#SizeDrawer [data-size-close]').forEach(el => {
        el.addEventListener('click', window.closeSizeDrawer);
      });
    }

    window.openSizeDrawer = function(btn) {
      sd_build();
      const picker = sd_findPicker(btn);
      if (!picker) {
        document.querySelector('variant-picker')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      window.__sizeDrawerPicker = picker;
      window.__sizeDrawerOrigin = btn;

      const t = document.getElementById('SizeDrawerTitle');
      const p = document.getElementById('SizeDrawerPrice');
      if (t) t.textContent = (btn && btn.dataset.productTitle) || '';
      if (p) p.textContent = (btn && btn.dataset.productPrice) || '';

      sd_renderOptions(picker);
      sd_refreshAddState();

      const drawer = document.getElementById('SizeDrawer');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    window.closeSizeDrawer = function() {
      const drawer = document.getElementById('SizeDrawer');
      if (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      }
      document.body.style.overflow = '';
    };

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') window.closeSizeDrawer();
    });
  }

  function camotecAtcReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  camotecAtcReady(() => {
    function forceButtonText() {
      const variantForm = document.querySelector('variant-picker');
      const submitBtns = document.querySelectorAll('.add-to-cart-button, .sticky-add-to-cart__button');
      const stickyWrapper = document.querySelector('sticky-add-to-cart');

      if (!variantForm || submitBtns.length === 0) return;

      const checkedRadios = variantForm.querySelectorAll('input[type="radio"]:checked');
      const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');

      if (checkedRadios.length > 0 && idInput && idInput.value) {
        const lastChecked = checkedRadios[checkedRadios.length - 1];
        const isAvailable = lastChecked.dataset.optionAvailable === 'true';

        if (stickyWrapper) {
          stickyWrapper.setAttribute('data-variant-available', isAvailable ? 'true' : 'false');
        }

        submitBtns.forEach(submitBtn => {
          const textSpans = submitBtn.querySelectorAll('.actual-btn-text');
          submitBtn.disabled = false;
          submitBtn.classList.remove('loading', 'is-unselected-state');

          if (isAvailable) {
            submitBtn.setAttribute('name', 'add');
            submitBtn.removeAttribute('onclick'); // снимаем наш кастомный клик (открытие дравера)

            if (submitBtn.closest('add-to-cart-component')) {
              submitBtn.setAttribute('type', 'submit');
              submitBtn.setAttribute('on:click', '/handleClick');
            } else {
              submitBtn.setAttribute('type', 'button');
              submitBtn.setAttribute('on:click', '/handleAddToCartClick');
            }

            if (textSpans.length) {
              textSpans.forEach(span => span.innerText = (window.camotecStrings && window.camotecStrings.addToCart) || 'Додати в кошик');
            }
          } else {
            submitBtn.removeAttribute('name');
            submitBtn.removeAttribute('on:click');
            submitBtn.setAttribute('type', 'button');

            submitBtn.setAttribute('onclick', 'window.openNotifyDrawer(this.dataset.productTitle, this.dataset.productPrice); return false;');

            if (textSpans.length) {
              textSpans.forEach(span => span.innerText = "Повідомити про наявність");
            }
          }
        });
      }
    }

    document.addEventListener('change', (e) => {
      if (e.target.closest('variant-picker')) {
        setTimeout(forceButtonText, 50);
        setTimeout(forceButtonText, 300);
      }
    });

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1 && (node.matches('.add-to-cart-button') || node.querySelector('.add-to-cart-button'))) {
              setTimeout(forceButtonText, 50);
              return;
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  function fillCheckmark(e) {
    var btn = e.target && e.target.closest && e.target.closest('.add-to-cart-button, add-to-cart-component');
    if (!btn) return;
    var root = btn.closest('add-to-cart-component') || btn;
    var slot = root.querySelector('[data-camotec-checkmark]');
    if (!slot || slot.firstElementChild) return;
    var tpl = document.getElementById('camotec-checkmark');
    if (tpl) slot.appendChild(tpl.content.cloneNode(true));
  }
  ['pointerdown', 'focusin', 'click'].forEach(function (ev) {
    document.addEventListener(ev, fillCheckmark, true);
  });
})();